export default {
  active: 'active',
  scheduled: 'scheduled',
  actionRequired: 'actionRequired',
  today: 'today',
};
